export default "__VITE_ASSET__9vnd93e$__"